import React from 'react';

export default React.createContext({
    session: {response: {}}
})
